import type { RouteObject } from 'react-router';
import { CashPage } from './cash/cash-page';
import { CommissionsPage } from './commissions/commissions-page';
import { ReportsPage } from './reports/reports-page';

export const appRoutes: RouteObject[] = [
  { path: 'caixa', element: <CashPage /> },
  { path: 'relatorios', element: <ReportsPage /> },
  { path: 'comissoes', element: <CommissionsPage /> },
];
